import { ActionContainer } from './styles';

export default function PersonActions({ verticalCenter, actionComponents }) {
  return <ActionContainer verticalCenter={verticalCenter}>{actionComponents}</ActionContainer>;
}
